import Help from 'components/commons/Help';
import ShareThisApp from 'components/commons/ShareThisApp';
import Edit from 'components/features/Edit';
import BaseLayout from 'components/layouts/BaseLayout';
import { appSlice } from 'modules/app/appSlice';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button } from 'react-native-paper';
import { useDispatch } from 'react-redux';
import { RouteName } from 'types/RootStackParamList';
import { useNavigation } from '@react-navigation/native';

const styles = StyleSheet.create({
	buttonRow: {
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
	},
});

const HomeScreen: React.VFC = () => {
	const navigation = useNavigation();

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(appSlice.actions.resetMessage());
	}, []);

	return (
		<BaseLayout
			headerChildren={
				<>
					<Help />
					<ShareThisApp />
				</>
			}
			mainChildren={<Edit />}
			footerChildren={
				<View style={styles.buttonRow}>
					<Button
						onPress={() => {
							navigation.navigate<RouteName>('Result');
						}}
						mode="contained"
						icon="send">
						作成する
					</Button>
				</View>
			}
		/>
	);
};

export default HomeScreen;
